var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coin-title d-flex mx-3 align-items-center"},[_c('p',[_vm._v("You Have: ")]),_c('img',{attrs:{"src":require("../../../assets/coin.png")}}),_c('p',[_vm._v(" "+_vm._s(_vm.coins)+" coins")])])}
var staticRenderFns = []

export { render, staticRenderFns }